import { useState } from 'react';

import { TextField, type TextFieldProps } from '../TextField/TextField';
import { PasswordToggle } from './PasswordToggle';

export type PasswordFieldProps = Omit<TextFieldProps, 'type' | 'adornment' | 'adornmentPosition'>;

export const PasswordField = ({
  ref: forwardedRef,
  ...props
}: TextFieldProps & {
  ref?: React.Ref<HTMLInputElement>;
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      adornment={<PasswordToggle showPassword={showPassword} togglePassword={togglePassword} />}
      adornmentPosition="right"
      ref={forwardedRef}
      {...props}
    />
  );
};

PasswordField.displayName = 'PasswordField';
